import { Component, Injector, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {EventService} from "../../../services/event.service";
import {TeamService} from "../../../services/team.service";
import {ImageService} from "../../../services/image.service";
import {ToastrService} from "ngx-toastr";
import {ProgressService} from "../../../services/progress.service";
import {NationalTeamsService} from "../../../services/national-teams.service";
import {FundraisingViewService} from "../../../services/fundraising-view.service";
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

@Component({
    selector: 'app-edit-team',
    templateUrl: './edit-team.component.html',
    styleUrls: ['./edit-team.component.scss']
})
export class EditTeamComponent extends BaseDialogComponent implements OnInit {
    name: string;
    model: any = {};
    currentImage: any = {
        fullImagePath: 'assets/modules/dummy-assets/common/img/avatars/1.jpg'
    };

    constructor(
        public activeModal: NgbActiveModal,
        public eventService: EventService,
        public teamService: TeamService,
        private imageService: ImageService,
        private ToastrService: ToastrService,
        private progressService: ProgressService,
        private nationalTeamsService: NationalTeamsService,
        private fundraisingViewService: FundraisingViewService,
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit() {
        this.name = this.getTeamName();
        if (this.getImageId()) {
            this.currentImage.imagePath = this.getImagePath();
            this.currentImage.fullImagePath = this.imageService.formatUrlForProgramGroupImagePath(this.getImagePath(), this.getProgramGroupImageUrl());
            this.currentImage.imageID = this.getImageId();
        }
    }

    closeModal() {
        this.activeModal.close();
    }

    onFormSubmit(f: any) {
        this.progressService.startProgress(false);
        this.model = {
            name: this.name,
            imageID: this.currentImage.imageID
        };
        this.teamService.saveTeamEdit(this.getTeamId(), this.model).subscribe(res => {
            this.ToastrService.success("Team updated successfully.");
            this.setTeamName();
            if(!this.fundraisingViewService.isNationalTeamView()) {
                var teamFormMembers = this.findTeamInTeamMembers(this.eventService.selectedEvent.gql.Participant[0].team.teamId);
                if(teamFormMembers) {
                    teamFormMembers.firstName = this.name;
                }
            }
            this.progressService.stopProgress(false);
        }, err => {
            this.ToastrService.error("Error happened during update.");
            this.progressService.stopProgress(false);
        });
        this.activeModal.dismiss();
    }

    findTeamInTeamMembers(teamId) {
        return this.eventService.selectedEvent.gql.Participant[0].team.teamMembers.find(function(teamMember) {
            return teamMember.teamMemberId === teamId * -1;
        });
    }

    private getTeamName() {
        if(this.fundraisingViewService.isNationalTeamView()) {
            return this.nationalTeamsService.selectedNationalTeam.name
        } else {
            return this.eventService.selectedEvent.team.name;
        }
    }

    private setTeamName() {
        if(this.fundraisingViewService.isNationalTeamView()) {
            this.nationalTeamsService.selectedNationalTeam.name = this.name;
        } else {
            this.eventService.selectedEvent.team.name = this.name;
        }
    }

    private getImageId() {
        if(this.fundraisingViewService.isNationalTeamView()) {
            return this.nationalTeamsService.selectedNationalTeam.imageId
        } else {
            return this.eventService.selectedEvent.team.imageId;
        }
    }

    private getImagePath() {
        if(this.fundraisingViewService.isNationalTeamView()) {
            return this.nationalTeamsService.selectedNationalTeam.imagePath
        } else {
            return this.eventService.selectedEvent.team.imagePath;
        }
    }

    private getTeamId() {
        if(this.fundraisingViewService.isNationalTeamView()) {
            return this.nationalTeamsService.selectedNationalTeam.teamId;
        } else {
            return this.eventService.selectedEvent.gql.Participant[0].team.teamId;
        }
    }

    private getProgramGroupImageUrl() {
        if(this.fundraisingViewService.isNationalTeamView()) {
            return this.nationalTeamsService.selectedNationalTeam.campaign.programGroup.imageUrl;
        } else {
            return this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.imageUrl;
        }
    }
}
